import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../components/layout/index.vue'
import Applicant from '../views/applicant/index.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Layout,
    redirect: '/applicant',
    children: [
      {
        path: '/applicant',
        name: 'applicant',
        component: Applicant,
        meta: {
          title: '常用申请人'
        }
      }
    ]
  },
  // 其他路由...
  // 在所有路由最后添加一个通配符路由
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
